import styled from '@emotion/styled';
import { boxSizes, gutterSizes } from '@gumtree/ui-library/src/base/theme';
import { Dialog } from '@gumtree/ui-library';


export const PostAJobDialog = styled(Dialog)<{ searchStatus: boolean, app: boolean }>`
    padding: 0;
    border-radius: ${boxSizes.borderRadius8};
    display: flex;
    flex-wrap: wrap;

    .dialog-title {
        position: sticky;
        left: 0px;
        top: 0px;
        background: white;
        z-index: 5;
        padding-right: 0;
        margin-bottom: 0;
        width: 100%;

        ${({ searchStatus }) => searchStatus && `
            padding: ${gutterSizes.xlarge};

            .search-bar > input {
                box-sizing: border-box;
                height: ${boxSizes.boxHeight};
                margin-right: 0;
                width: 100%;
                outline: none;
            }

            .search-button {
                transform: translateX(15px);
            }
        `}
    }

    .dialog {
        height: ${({ app }) => app ? '100%' : '85%'};
        min-width: auto;
        width: 100%;

        .dialog-close {
            order: 2;
            background: transparent;
            position: absolute;
            border-radius: 0px;
            top: 0px;
            right: 0px;
            z-index: 6;

            .icon.icon--clear {
                top: 0px;
                right: 0px;
                transform: none;
            }
        }

    }

    .dialog-content {
        order: 3;
        width: 100%;
        height: calc(100% - 52px);
        overflow-y: auto;
    }
`;

export const ContentWrapper = styled.div`
    padding: ${gutterSizes.xlarge};
    box-sizing: border-box;
    padding: ${gutterSizes.xlarge} ${gutterSizes.xlarge} 70px;
    height: 100%;
    max-height: 630px;
    overflow: auto;

    && label {
        padding: 0;
    }
`;
